'use strict';

module.exports = {
  hybrid: 'hybrid',
  static: 'static',
  calculated: 'calculated',
};
